/**
 * Timeline Block - Frontend JS
 * Handles horizontal drag-to-scroll and button navigation at desktop,
 * scroll-based button navigation at mobile,
 * and hides controls when content fits the viewport.
 */

const LG_BREAKPOINT = 992;

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.commcore-timeline').forEach(initTimeline);
});

function isDesktop() {
	return window.innerWidth >= LG_BREAKPOINT;
}

function initTimeline(section) {
	const inner = section.querySelector('.commcore-timeline__inner');
	const controls = section.querySelector('.commcore-timeline__controls');
	if (!inner) return;

	let currentX = 0;
	let isDragging = false;
	let startX = 0;
	let startTranslate = 0;

	function getMinX() {
		const innerWidth = inner.scrollWidth;
		const sectionWidth = section.offsetWidth;
		return Math.min(0, sectionWidth - innerWidth);
	}

	function clamp(value) {
		return Math.max(getMinX(), Math.min(0, value));
	}

	function setPosition(x, smooth) {
		currentX = clamp(x);
		inner.style.transition = smooth ? 'transform 0.4s ease' : 'none';
		inner.style.transform = `translateX(${currentX}px)`;
	}

	function clearTransform() {
		currentX = 0;
		inner.style.transition = '';
		inner.style.transform = '';
	}

	/**
	 * Show or hide controls based on whether the content overflows.
	 */
	function updateControlsVisibility() {
		if (!controls) return;

		if (isDesktop()) {
			// Desktop: compare scrollWidth (content) vs section width
			const overflows = inner.scrollWidth > section.offsetWidth;
			controls.style.display = overflows ? '' : 'none';
		} else {
			// Mobile: compare scrollWidth vs clientWidth
			const overflows = inner.scrollWidth > inner.clientWidth;
			controls.style.display = overflows ? '' : 'none';
		}
	}

	// --- Button navigation ---
	if (controls) {
		const buttons = controls.querySelectorAll('button');
		const stepSize = () => section.offsetWidth * 0.5;

		buttons.forEach((btn) => {
			btn.addEventListener('click', () => {
				const isLeft = btn.classList.contains('btn--gray-arrow-left');

				if (isDesktop()) {
					// Desktop: translateX-based navigation
					if (isLeft) {
						setPosition(currentX + stepSize(), true);
					} else {
						setPosition(currentX - stepSize(), true);
					}
				} else {
					// Mobile: snap to next/previous card
					const items = Array.from(inner.querySelectorAll('.commcore-timeline__item'));
					const scrollLeft = inner.scrollLeft;
					const threshold = 2; // px tolerance for current position

					if (isLeft) {
						// Find the last item whose left edge is before the current scroll
						for (let i = items.length - 1; i >= 0; i--) {
							if (items[i].offsetLeft < scrollLeft - threshold) {
								items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
								break;
							}
						}
					} else {
						// Find the first item whose left edge is after the current scroll
						for (let i = 0; i < items.length; i++) {
							if (items[i].offsetLeft > scrollLeft + threshold) {
								items[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
								break;
							}
						}
					}
				}
			});
		});
	}

	// --- Drag to scroll (desktop only, pointer events) ---
	inner.addEventListener('pointerdown', (e) => {
		if (!isDesktop()) return;
		if (e.button !== 0) return;

		isDragging = true;
		startX = e.clientX;
		startTranslate = currentX;
		inner.setPointerCapture(e.pointerId);
		inner.style.cursor = 'grabbing';
		inner.style.transition = 'none';
		e.preventDefault();
	});

	inner.addEventListener('pointermove', (e) => {
		if (!isDragging) return;
		const dx = e.clientX - startX;
		setPosition(startTranslate + dx, false);
	});

	inner.addEventListener('pointerup', endDrag);
	inner.addEventListener('pointercancel', endDrag);

	function endDrag() {
		if (!isDragging) return;
		isDragging = false;
		inner.style.cursor = '';
	}

	// Prevent link/image drag interference
	inner.addEventListener('dragstart', (e) => e.preventDefault());

	// On resize, reset transform if crossing to mobile & update controls
	window.addEventListener('resize', () => {
		if (isDesktop()) {
			setPosition(currentX, false);
		} else {
			clearTransform();
		}
		updateControlsVisibility();
	});

	// Initial check
	updateControlsVisibility();
}
